import React from 'react'
import { Tooltip, Typography } from '@mui/material'

const SFTooltip = (props) => {
    return (
        <Tooltip
            title={<Typography className='text-white' fontSize={14}>
                {props.text}</Typography>}
            arrow
            placement={props.placement ? props.placement : "top"}
        >
            {props.children}
        </Tooltip>
    )
}
export default SFTooltip;